var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoJdNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Logo-JD-Navigation",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Logo",
    d: "M24.245 9.433c-.415 0-.731.022-.9.039L21.336 21.7a9.474 9.474 0 0 0 .971.049c2.47 0 6.745-.806 7.658-6.191a5.158 5.158 0 0 0-.818-4.352c-1.294-1.541-3.626-1.769-4.9-1.769m-1.473 17.869h-8l.035-.215L18.613 4h7.925a9.194 9.194 0 0 1 7.295 3 10.725 10.725 0 0 1 1.985 8.706c-.918 5.585-5.4 11.6-13.045 11.6M1.036 28a5.146 5.146 0 0 1-.865-.06L0 27.91l.757-5.83h.246c8.466 0 10.017-17.689 10.032-17.87l.015-.172h5.837l-.03.212C13.6 26.287 3.92 28 1.036 28",
    transform: "translate(0 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJdNavigation);
export default __webpack_public_path__ + "static/media/logo-jd-navigation.4129dda1.svg";
export { ForwardRef as ReactComponent };